import { ReactNode } from 'react';

interface AuthFieldProps {
  label: string;
  htmlFor: string;
  children: ReactNode;
  className?: string;
}

export function AuthField({ label, htmlFor, children, className }: AuthFieldProps) {
  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="auth-field-label">
        {label}
      </label>
      {children}
    </div>
  );
}
